export default {"src":"/_next/static/media/2025-easiest-to-do-business.88387c34.svg","height":127,"width":98,"blurWidth":0,"blurHeight":0};